module.exports = __webpack_public_path__ + "img/close.412a0119.svg";